import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=6f5b8eae&scoped=true&"
import script from "./authentication.vue?vue&type=script&lang=js&"
export * from "./authentication.vue?vue&type=script&lang=js&"
import style0 from "./authentication.vue?vue&type=style&index=0&id=6f5b8eae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b8eae",
  null
  
)

export default component.exports